var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("div", { staticClass: "row mt-3" }, [
          _c(
            "div",
            { staticClass: "col-md-12 text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "success",
                    size: "sm",
                    title: "Adicionar PDV"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.novoPDV.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" Adicionar Ponto de Venda\n                ")
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "mt-2" },
          [
            _c("b-table", {
              attrs: {
                items: _vm.dataComputed,
                fields: _vm.colunas,
                stacked: "md",
                "show-empty": "",
                "empty-text": "Nenhum Ponto de Venda Encontrado",
                small: "",
                striped: "",
                busy: _vm.loading
              },
              scopedSlots: _vm._u([
                {
                  key: "table-busy",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center text-primary my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Buscando PDVs...")])
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "cell(actions)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1",
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.edit(row.item.id)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-edit" })]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal fade", attrs: { id: "createModal" } }, [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content modal-lg" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm.criar
                    ? _c("h4", { staticClass: "modal-title" }, [
                        _vm._v(" Criar Ponto de Venda")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.criar
                    ? _c("h4", { staticClass: "modal-title" }, [
                        _vm._v(" Alterar Ponto de Venda " + _vm._s(_vm.nome))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(0)
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    staticStyle: { width: "800px" }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { width: "800px" }
                        },
                        [
                          _c(
                            "b-tabs",
                            {
                              attrs: {
                                "content-class": "mt-3",
                                pills: "",
                                fill: "",
                                justified: "",
                                align: "center"
                              }
                            },
                            [
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    active: "",
                                    title: "Dados",
                                    id: "first-tab"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row g-0" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Nome ")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.nome,
                                              expression: "nome"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.nome },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.nome = $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("CPF ")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "###.###.###-##",
                                              expression: "'###.###.###-##'"
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.cpf,
                                              expression: "cpf"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            placeholder: "000.000.000-00"
                                          },
                                          domProps: { value: _vm.cpf },
                                          on: {
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.cpf = $event.target.value
                                              },
                                              _vm.validarCPF
                                            ]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.cpfIsValid === false
                                          ? _c(
                                              "p",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  "\n                                                        CPF Inválido\n                                                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Email")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.email,
                                              expression: "email"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "email" },
                                          domProps: { value: _vm.email },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.email = $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Código PDV")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.cod_pdv,
                                              expression: "cod_pdv"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "8"
                                          },
                                          domProps: { value: _vm.cod_pdv },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.cod_pdv = $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Senha de acesso")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.senha_pdv,
                                              expression: "senha_pdv"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "password" },
                                          domProps: { value: _vm.senha_pdv },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.senha_pdv =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Confirmar Senha")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.senha_pdv_confirm,
                                              expression: "senha_pdv_confirm"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "password" },
                                          domProps: {
                                            value: _vm.senha_pdv_confirm
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.senha_pdv_confirm =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Status")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.status,
                                                expression: "status"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: { name: "", id: "" },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.status = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              { domProps: { value: 1 } },
                                              [_vm._v("Ativo")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { domProps: { value: 0 } },
                                              [_vm._v("Inativo")]
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("CEP")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.cep,
                                              expression: "cep"
                                            },
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "## ###-###",
                                              expression: "'## ###-###'"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.cep },
                                          on: {
                                            keyup: _vm.buscacep,
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.cep = $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Estado")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.estado,
                                                expression: "estado"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              name: "",
                                              id: "",
                                              disabled: ""
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.estado = $event.target
                                                    .multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                                _vm.getCidades
                                              ]
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "-1",
                                                  disabled: ""
                                                }
                                              },
                                              [_vm._v("Selecione Estado")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(_vm.estados, function(
                                              estado,
                                              index
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: index,
                                                  domProps: { value: estado.uf }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(estado.nome)
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Cidade")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.cidade,
                                                expression: "cidade"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              name: "",
                                              id: "",
                                              disabled: ""
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.cidade = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "-1",
                                                  disabled: ""
                                                }
                                              },
                                              [_vm._v("Selecione Cidade")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(_vm.cidades, function(
                                              cidade,
                                              index
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: index,
                                                  domProps: {
                                                    value: cidade.ibge
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(cidade.nome)
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Logradouro")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.logradouro,
                                              expression: "logradouro"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.logradouro },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.logradouro =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Bairro")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.bairro,
                                              expression: "bairro"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.bairro },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.bairro = $event.target.value
                                            }
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Complemento")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.complemento,
                                              expression: "complemento"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.complemento },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.complemento =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: { id: "second-tab", title: "Contatos" }
                                },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "table",
                                      { staticClass: "table table-responsive" },
                                      [
                                        _c(
                                          "tbody",
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-success text-right",
                                                on: { click: _vm.addContato }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-plus"
                                                }),
                                                _vm._v(" Contato")
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(_vm.contatos, function(
                                              contato,
                                              index
                                            ) {
                                              return _c("tr", { key: index }, [
                                                _c("td", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [_vm._v("Tipo")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                contato.tipo,
                                                              expression:
                                                                "contato.tipo"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            name: "",
                                                            id: ""
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                contato,
                                                                "tipo",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "F"
                                                              }
                                                            },
                                                            [_vm._v("Fixo")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "M"
                                                              }
                                                            },
                                                            [_vm._v("Móvel")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [_vm._v("Numero")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: [
                                                              "(##) ####-####",
                                                              "(##) #####-####"
                                                            ],
                                                            expression:
                                                              "['(##) ####-####', '(##) #####-####']"
                                                          },
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              contato.numero,
                                                            expression:
                                                              "contato.numero"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value: contato.numero
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              contato,
                                                              "numero",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [_vm._v("Whatsapp")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                contato.whatsapp,
                                                              expression:
                                                                "contato.whatsapp"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            name: "",
                                                            id: ""
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                contato,
                                                                "whatsapp",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value: 0
                                                              }
                                                            },
                                                            [_vm._v("Não")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value: 1
                                                              }
                                                            },
                                                            [_vm._v("Sim")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "btn-remove-contato"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-danger",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeContato(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-trash-alt"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ])
                                            })
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "hide-footer text-right mb-2" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-3",
                                  attrs: { variant: "primary", size: "sm" },
                                  on: { click: _vm.savePDV }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-save" }),
                                  _vm._v(
                                    " Salvar\n                                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-3",
                                  attrs: {
                                    variant: "secondary",
                                    size: "sm",
                                    "data-dismiss": "modal"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Cancelar\n                                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c8bbcdd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8bbcdd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pdv/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3c8bbcdd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pdv/Main.vue
// module chunks = 2